export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" rx="12" fill="white" fillOpacity="0.4" />
            <path
                d="M11.168 14.1761C10.672 11.5201 14.448 10.8001 14.448 8.97607C14.448 7.87207 13.648 7.07207 12.016 7.07207C10.928 7.07207 9.91999 7.55207 8.99199 8.52807L8.12799 7.72807C9.18399 6.60807 10.432 5.87207 12.176 5.87207C14.432 5.87207 15.872 7.02407 15.872 8.86407C15.872 11.2801 12.048 11.7761 12.48 14.1761H11.168ZM11.856 18.1281C11.28 18.1281 10.816 17.7121 10.816 17.0721C10.816 16.4321 11.28 16.0001 11.856 16.0001C12.416 16.0001 12.88 16.4321 12.88 17.0721C12.88 17.7121 12.416 18.1281 11.856 18.1281Z"
                fill="white"
            />
        </svg>
    );
}
